import Label from '../../../../components/Label';
import * as Styled from './ScoreDetail.styles';

interface ScoreDetailProps {
  label?: string;
  score?: string;
  scoreLabel?: string;
  maxScore: number;
}

const ScoreDetail = ({ label, scoreLabel, score, maxScore }: ScoreDetailProps) => {
  return (
    <Styled.Container>
      {label && <Label>{label}</Label>}

      <Styled.ScoreContainer>
        <span>{scoreLabel || `${Number(score)}/${maxScore}`}</span>
        <Styled.ScoreIndicatorContainer>
          {Array.from(new Array(maxScore)).map((_, index) => {
            const numberScore = Number(score);
            const roundedCeilScore = Math.ceil(numberScore);
            const decimalPart = numberScore % 1;
            let width = '100%';

            if (decimalPart && roundedCeilScore === index + 1) {
              width = `${(decimalPart % 1) * 100}%`;
            }

            return (
              <Styled.OuterScoreIndicator key={`score_${index}`}>
                <Styled.InnerScoreIndicator
                  width={width}
                  maxScore={maxScore}
                  score={index + 1 <= roundedCeilScore ? numberScore : 0}
                />
              </Styled.OuterScoreIndicator>
            );
          })}
        </Styled.ScoreIndicatorContainer>
      </Styled.ScoreContainer>
    </Styled.Container>
  );
};

export default ScoreDetail;
